<template>
  <Button
    v-if="mounted"
    variant="ghost"
    size="icon"
    @click="toggleTheme"
    class="absolute top-4 right-4 rounded-full hover:bg-accent"
  >
    <Sun class="h-5 w-5 rotate-0 scale-100 transition-transform dark:-rotate-90 dark:scale-0" />
    <Moon class="absolute h-5 w-5 rotate-90 scale-0 transition-transform dark:rotate-0 dark:scale-100" />
    <span class="sr-only">Toggle theme</span>
  </Button>
  <Button
    v-else
    variant="ghost"
    size="icon"
    class="absolute top-4 right-4 rounded-full hover:bg-accent opacity-0"
  >
    <span class="sr-only">Toggle theme</span>
  </Button>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { Moon, Sun } from 'lucide-vue-next'
import { useColorMode } from '@vueuse/core' // Import useColorMode
import { Button } from '@/components/ui/button' // Assuming a button component exists

const mode = useColorMode() // Use useColorMode to manage theme

const mounted = ref(false)

onMounted(() => {
  mounted.value = true
})

const toggleTheme = () => {
  mode.value = mode.value === 'dark' ? 'light' : 'dark'
}
</script> 